import { Button } from '@eventbrite/marmalade';
import styles from './ContactButton.module.scss';
import { FormattedMessage } from 'react-intl';
import { useAppContext } from '../../context/AppContext';
import { withContactOrganizerQuery } from '@/utils/organizerContactUrl';

export type ContactButtonProps = {
  organizerId: string;
  eventId: string;
  organizerName?: string;
};

export const ContactButton = ({ organizerId, eventId, organizerName }: ContactButtonProps) => {
  const { data: appContextData } = useAppContext();
  const domainUrl = appContextData.serverUrl;

  if (!organizerId) {
    return null;
  }

  const handleClick = () => {
    const base = `${domainUrl}/o/${organizerId}`;
    window.location.href = withContactOrganizerQuery(base, eventId);
  };

  return (
    <Button variant="secondary" className={styles.contactButton} onClick={handleClick} data-testid="contact-button">
      {organizerName ? <FormattedMessage id="Contact" /> : <FormattedMessage id="Contact organizer" />}
    </Button>
  );
};
